


// Handle tab switching
    document.querySelectorAll('.tab').forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all tabs
        document.querySelectorAll('.tab').forEach(tab => tab.classList.remove('active'));
        // Remove active class from all content
        document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));
        
        // Add active class to clicked tab
        tab.classList.add('active');
        // Add active class to corresponding content
        const tabId = tab.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('active');
      });
    });

    // Set initial active tab
    document.querySelector('.tab').classList.add('active');
    document.querySelector('.tab-content').classList.add('active');

// Load more js


document.addEventListener('DOMContentLoaded', function () {
  const readMoreBtn = document.getElementById('read-more-btn');
  const descriptionWrapper = document.querySelector('.description-wrapper');
  const fadeOverlay = document.querySelector('.fade-overlay');

  readMoreBtn.addEventListener('click', function () {
    if (descriptionWrapper.classList.contains('expanded')) {
      // Collapse the content
      descriptionWrapper.classList.remove('expanded');
      descriptionWrapper.style.maxHeight = '150px';
      fadeOverlay.style.display = 'block';
      readMoreBtn.textContent = 'Bővebben';
    } else {
      // Expand the content
      descriptionWrapper.classList.add('expanded');
      descriptionWrapper.style.maxHeight = descriptionWrapper.scrollHeight + 'px';
      fadeOverlay.style.display = 'none';
      readMoreBtn.textContent = 'Bezárás';
    }
  });
});






